var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component } from 'angular-ts-decorators';
import template from './login-oauth.component.html';
let LoginOAuthComponent = class LoginOAuthComponent {
    $http;
    /** Contains a map of all available OAuth providers fetched from the backend when the component is initialized. */
    providers = {};
    /** Indicates if resolving the OAuth providers failed. */
    failed = false;
    // Via bindings:
    locale;
    redirectUrl;
    // Minification-safe CI injections, everything @Inject()ed somewhere must be mentioned here:
    static $inject = ['$http'];
    constructor($http) {
        this.$http = $http;
    }
    ngOnInit() {
        this.$http
            .get('/oidc/providers')
            .then((response) => {
            for (const provider of response.data.providers) {
                // Append the currently in use locale to each provider url to ensure a consistent UX while
                // using our site
                if (this.locale) {
                    const url = new URL(provider.url);
                    url.searchParams.set('locale', this.locale);
                    provider.url = url.href;
                }
                this.providers[provider.name] = provider;
            }
        })
            .catch(() => {
            this.failed = true;
        });
    }
    getLoginUrl(providerName) {
        const provider = this.providers[providerName];
        if (!provider) {
            return '';
        }
        // Wrap the provider url in a redirect to analytics-web server because we
        // need to set the code verifier in the user session.
        return `/login/sso?loginUrl=${encodeURIComponent(provider.url)}&redirect_url=${encodeURIComponent(this.redirectUrl)}`;
    }
};
LoginOAuthComponent = __decorate([
    Component({
        selector: 'login-oauth',
        template,
        bindings: {
            locale: '@',
            redirectUrl: '@',
        },
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof ng !== "undefined" && ng.IHttpService) === "function" ? _a : Object])
], LoginOAuthComponent);
export { LoginOAuthComponent };
